module.exports = __webpack_public_path__ + "img/VolumeHigh.0280597e.png";